import { render, staticRenderFns } from "./boardRight.vue?vue&type=template&id=452654b5&scoped=true&"
import script from "./boardRight.vue?vue&type=script&lang=js&"
export * from "./boardRight.vue?vue&type=script&lang=js&"
import style0 from "./boardRight.vue?vue&type=style&index=0&id=452654b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452654b5",
  null
  
)

export default component.exports